import React from "react"
import { graphql, useLazyLoadQuery } from "react-relay"

import { PhaseItemTooltipBudgetSectionQuery } from "~/ProjectPlanner/Phases/__generated__/PhaseItemTooltipBudgetSectionQuery.graphql"

import { getDefaultRate } from "~/helpers/rate-helpers"

import { RateCard } from "~/forms/ProjectBudgetForm/types"

type Props = {
  projectId: number
  phase: {
    id: number
    revenue_budget: number
  }
  rateCards: readonly RateCard[]
}

const PhaseItemTooltipBudgetSection = ({
  projectId,
  phase,
  rateCards,
}: Props) => {
  const query = useLazyLoadQuery<PhaseItemTooltipBudgetSectionQuery>(
    graphql`
      query PhaseItemTooltipBudgetSectionQuery($projectId: Int!) {
        projects_by_pk(id: $projectId) {
          id
          rate_card_id
          project_rates {
            id
            role_id
            rate: rate_private
          }
          summary {
            role_id
            minutes_phase_id
            total_billable_minutes
            actual_phase_id
          }
        }
      }
    `,
    { projectId: projectId },
  )

  const project = query.projects_by_pk

  if (!project) {
    return null
  }

  const phaseSummaries = project.summary.filter(
    (s) => s.minutes_phase_id === phase.id || s.actual_phase_id === phase.id,
  )
  const rateMap = new Map(
    project.project_rates.map((rate) => [rate.role_id, rate.rate ?? 0]),
  )
  const rateCard = rateCards.find((rc) => rc.id === project.rate_card_id)

  const totalCost = phaseSummaries.reduce((acc, summary) => {
    const rate =
      rateMap.get(summary.role_id) ?? getDefaultRate(rateCard, summary.role_id)
    return acc + (summary.total_billable_minutes / 60) * rate
  }, 0)

  const revenueBudget = phase.revenue_budget || 0
  const remainingBudget = revenueBudget - totalCost

  return (
    <>
      <div>
        <b>Budget:</b> ${revenueBudget}
      </div>
      <div>
        <b>Remaining:</b> ${remainingBudget}
      </div>
    </>
  )
}

export default PhaseItemTooltipBudgetSection
